import React from "react";
import styled from "styled-components";
import { useTicketSearch } from "../contexts/TicketSearchContext";

const IncidentsTable = () => {
  const {
    tickets,
    loading,
    currentPage,
    totalPages,
    changePage,
    states,
  } = useTicketSearch();
  const BASE_URL = process.env.REACT_APP_URL_TICKET;

  if (loading) return <p>Cargando tickets...</p>;

  // Función para calcular las páginas visibles en la paginación
  const getVisiblePages = () => {
    const pages = [];
    const start = Math.max(1, currentPage - 3);
    const end = Math.min(totalPages, currentPage + 3);
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <Container>
      {/* Mostrar como tabla en pantallas grandes */}
      <Table>
        <thead>
          <tr>
            <TableHeader>Id</TableHeader>
            <TableHeader>Título</TableHeader>
            <TableHeader>Entidad</TableHeader>
            <TableHeader>Fecha de Creación</TableHeader>
            <TableHeader>Estado</TableHeader>
          </tr>
        </thead>
        <tbody>
          {tickets.length > 0 ? (
            tickets.map((ticket) => (
              <TableRow key={ticket[2]}>
                <TableCell>{ticket[2]}</TableCell>
                <TableCell>
                  <Link
                    href={`${BASE_URL}?id=${ticket[2]}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {ticket[1]}
                  </Link>
                </TableCell>
                <TableCell>{ticket[80]?.split(" > ").pop()}</TableCell>
                <TableCell>
                  {new Date(ticket[15]).toLocaleString("es-ES")}
                </TableCell>
                <TableCell>
                  {states.find((state) => state.id === ticket[12])?.name}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <EmptyMessage>
              <td colSpan="5">No hay incidencias que mostrar.</td>
            </EmptyMessage>
          )}
        </tbody>
      </Table>

      {/* Mostrar como tarjetas en pantallas pequeñas */}
      <CardsContainer>
        {tickets.length > 0 ? (
          tickets.map((ticket) => (
            <Card key={ticket[2]}>
              <CardField>
                <strong>Id:</strong> {ticket[2]}
              </CardField>
              <CardField>
                <strong>Título:</strong>{" "}
                <Link
                  href={`${BASE_URL}?id=${ticket[2]}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {ticket[1]}
                </Link>
              </CardField>
              <CardField>
                <strong>Entidad:</strong> {ticket[80]?.split(" > ").pop()}
              </CardField>
              <CardField>
                <strong>Fecha de Creación:</strong>{" "}
                {new Date(ticket[15]).toLocaleString("es-ES")}
              </CardField>
              <CardField>
                <strong>Estado:</strong>{" "}
                {states.find((state) => state.id === ticket[12])?.name}
              </CardField>
            </Card>
          ))
        ) : (
          <EmptyMessage>
            <p>No hay incidencias que mostrar.</p>
          </EmptyMessage>
        )}
      </CardsContainer>
            {/* Paginación */}
            <PaginationContainer>
        <PaginationButton
          onClick={() => changePage(1)}
          disabled={currentPage === 1}
        >
          Primera
        </PaginationButton>
        <PaginationButton
          onClick={() => changePage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          &laquo; Anterior
        </PaginationButton>

        {getVisiblePages().map((page) => (
          <PageNumberButton
            key={page}
            isActive={page === currentPage}
            onClick={() => changePage(page)}
          >
            {page}
          </PageNumberButton>
        ))}

        <PaginationButton
          onClick={() => changePage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Siguiente &raquo;
        </PaginationButton>
        <PaginationButton
          onClick={() => changePage(totalPages)}
          disabled={currentPage === totalPages}
        >
          Última
        </PaginationButton>
      </PaginationContainer>
    </Container>
  );

};

const Container = styled.div`
  width: 100%;
  margin-top: 20px;
  overflow-x: auto; /* Permitir desplazamiento horizontal si es necesario */

  @media (max-width: 768px) {
    padding: 0 10px; /* Añade algo de margen en pantallas pequeñas */
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  border: 1px solid #dee2e6;

  @media (max-width: 768px) {
    display: none; /* Ocultar la tabla en pantallas pequeñas */
  }
`;


const TableHeader = styled.th`
  padding: 10px;
  background-color: #343a40;
  color: white;
  text-align: left;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f8f9fa;
  }
`;

const TableCell = styled.td.attrs((props) => ({
  "data-isentity": props.isentity || null, // Si necesitas que llegue al DOM con un atributo data
}))`
  padding: 10px;
  border: 1px solid #dee2e6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: ${({ isentity }) => (isentity ? "200px" : "650px")};
`;


const EmptyMessage = styled.tr`
  text-align: center;
  td {
    padding: 20px;
    color: #6c757d;
  }
`;

const PaginationContainer = styled.div`
display: flex;
justify-content: center;
align-items: center;
margin-top: 20px;
flex-wrap: wrap; /* Permitir que los botones se ajusten */

@media (max-width: 768px) {
  justify-content: flex-start; /* Cambiar alineación para pantallas pequeñas */
}
`;

const PaginationButton = styled.button`
margin: 5px 5px;
padding: 10px;
background-color: #007bff;
color: white;
border: none;
border-radius: 3px;
cursor: pointer;

&:disabled {
  background-color: #dee2e6;
  color: #6c757d;
  cursor: not-allowed;
}
`;


const PageNumberButton = styled.button`
  margin: 0 3px;
  padding: 5px 10px;
  background-color: ${({ isActive }) => (isActive ? "#007bff" : "#f8f9fa")};
  color: ${({ isActive }) => (isActive ? "white" : "#343a40")};
  border: 1px solid #dee2e6;
  border-radius: 3px;
  cursor: ${({ isActive }) => (isActive ? "default" : "pointer")};
  pointer-events: ${({ isActive }) => (isActive ? "none" : "auto")};
`;

const Link = styled.a`
  color: #007bff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
const CardsContainer = styled.div`
  display: none; /* Ocultar las tarjetas por defecto */

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 10px; /* Espacio entre tarjetas */
  }
`;

const Card = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 10px;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const CardField = styled.div`
  margin-bottom: 5px;

  strong {
    display: inline-block;
    margin-right: 5px;
  }
`;



export default IncidentsTable;
